import {
  ConversationMessageContentType,
  type IConversationMessage,
} from 'src/@types/conversation';
import type { Slide } from 'src/components/lightbox';
import {
  isImageMimeType,
  isVideoMimeType,
} from 'src/sections/@dashboard/chat/ChatConversation/shared/utils';

export const createSlideFromMessage = (
  message: IConversationMessage,
  mediaContent: string,
): Slide | undefined => {
  if (!message.mediaRef || (!message.mimeType && !message.contentType)) return;

  if (isImageMessage(message)) {
    return createImageSlide(mediaContent);
  }
  if (isVideoMessage(message)) {
    return createVideoSlide(message, mediaContent);
  }
  if (isPdfMessage(message)) {
    return createPdfSlide(mediaContent);
  }

  return;
};

const isImageMessage = (message: IConversationMessage): boolean => {
  return (
    message.contentType === ConversationMessageContentType.IMAGE ||
    (!!message.mimeType && isImageMimeType(message.mimeType))
  );
};

const isVideoMessage = (message: IConversationMessage): boolean => {
  const isFile = message.contentType === ConversationMessageContentType.FILE;
  return (
    message.contentType === ConversationMessageContentType.VIDEO ||
    (!!message.mimeType && isFile && !!isVideoMimeType(message.mimeType))
  );
};

const isPdfMessage = (message: IConversationMessage): boolean => {
  return message.mimeType === 'application/pdf';
};

const createImageSlide = (mediaContent: string): Slide => {
  return { type: 'image', src: mediaContent };
};
const createVideoSlide = (
  message: IConversationMessage,
  mediaContent: string,
): Slide => {
  return {
    type: 'video',
    width: 1280,
    height: 720,
    sources: [{ type: message.mimeType || 'video.mp4', src: mediaContent }],
  };
};

const createPdfSlide = (mediaContent: string): Slide => {
  return { type: 'pdf', src: mediaContent };
};
